module.exports = __webpack_public_path__ + "img/content_app-gutschein.fe757f4e.svg";